export default __webpack_public_path__ + "static/media/Syl.055529a7.jpg";